import * as React from 'react';
import { Text as AriaText } from 'react-aria-components';

import { cx } from '../../../utils/cx';

import type { TextProps as AriaTextProps } from 'react-aria-components';

interface IHintTextProps extends AriaTextProps {
  /** Indicates that the hint text is an error message. */
  isInvalid?: boolean;
  ref?: React.Ref<HTMLElement>;
  children: React.ReactNode;
}

const HintText = ({ isInvalid, className, ...props }: IHintTextProps) => {
  return (
    <AriaText
      {...props}
      slot={isInvalid ? 'errorMessage' : 'description'}
      className={cx(
        'text-tertiary text-sm',

        // Invalid state
        isInvalid && 'text-error-primary',
        'group-invalid:text-error-primary',

        className
      )}
    />
  );
};
HintText.displayName = 'HintText';

export default HintText;
